import styled, { css } from 'styled-components';

export const DropdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  gap: 12px;
  width: 100%;
`;

export const DropdownTitle = styled.div<{ $fullWidth?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${({ $fullWidth }) =>
    $fullWidth ? 'space-between' : 'center'};
  gap: 3px;
  cursor: pointer;
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : undefined)};
  transition: 0.2s;

  &:hover {
    color: ${({ theme }) => theme.colors.default[300]};
  }
`;

export const DropdownContent = styled.div<{ $expanded: boolean }>`
  overflow: hidden;
  display: ${({ $expanded }) => ($expanded ? 'flex' : 'none')};
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;

export const ExpandArrowContainer = styled.span<{ $expanded: boolean }>`
  transition: 0.2s;
  cursor: pointer;

  span {
    svg {
      width: 14px;
    }
  }

  ${(props) =>
    props.$expanded &&
    css`
      transform: rotate(180deg);

      span svg path {
        stroke: ${(props) => props.theme.colors.base};
      }
    `}
`;
